// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
// import 'jquery.maskedinput/src/jquery.maskedinput';
// import './lib/wl-share';

// Framework
// import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/aos';
// import './site/scrolling-grid';
// import './site/back-to-top';
// import './site/home-animation';
// import './site/mobile-nav';
// import './site/search-autosuggest';
// import './site/side-nav';
// import './site/sticky-header';
import './site/feedback-submit';
import './site/star-rating';
import './site/video-modals';
import './site/youtube-video';

// // Apply input masks
// $('.mask-input-phone').mask('(999) 999-9999');
// $('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// // Init single carousel
// const carouselSingle = carousels('[data-carousel="single"]', {
//   autoplay: true,
//   dots: true,
//   infinite: true,
//   speed: 500
// });

// // Init multiple carousel
// const carouselMultiple = carousels('[data-carousel="multiple"]', {
//   dots: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     }
//   ]
// });

// // Init timeline carousel
// const carouselTimelineLg = carousels('[data-carousel="timeline_lg"]', {
//   autoplay: false,
//   dots: false,
//   arrows: true,
//   asNavFor: '.carousel-dot-container-lg',
//   infinite: false,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   speed: 1100
// });

// const carouselTimelineNavLg = carousels('[data-carousel="timeline_nav_lg"]', {
//   slidesToShow: 13,
//   slidesToScroll: 1,
//   asNavFor: '.timeline-carousel-lg',
//   centerMode: false,
//   focusOnSelect: true,
//   arrows: false,
//   infinite: false,
//   responsive: [
//     {
//       breakpoint: 1330,
//       settings: {
//         slidesToShow: 8
//       }
//     }
//   ]
// });

// const carouselTimelineSm = carousels('[data-carousel="timeline_sm"]', {
//   autoplay: false,
//   dots: false,
//   arrows: false,
//   asNavFor: '.carousel-dot-container-sm',
//   infinite: false,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   speed: 500
// });

// const carouselTimelineNavSm = carousels('[data-carousel="timeline_nav_sm"]', {
//   slidesToShow: 4,
//   slidesToScroll: 2,
//   asNavFor: '.timeline-carousel-sm',
//   centerMode: false,
//   focusOnSelect: true,
//   arrows: false,
//   infinite: false
// });

// const logoSliderLg = carousels('[data-carousel="logo-slider-lg"]', {
//   autoplay: true,
//   dots: false,
//   arrows: false,
//   infinite: true,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   autoplaySpeed: 0,
//   speed: 4000,
//   cssEase: 'linear',
//   draggable: false,
//   swipe: false,
//   pauseOnFocus: false,
//   pauseOnHover: false
// });

// const logoSliderMd = carousels('[data-carousel="logo-slider-md"]', {
//   autoplay: true,
//   dots: false,
//   arrows: false,
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplaySpeed: 0,
//   speed: 7000,
//   cssEase: 'linear',
//   draggable: false,
//   swipe: false,
//   pauseOnFocus: false,
//   pauseOnHover: false
// });

// const logoSliderSm = carousels('[data-carousel="logo-slider-sm"]', {
//   autoplay: true,
//   dots: false,
//   arrows: false,
//   infinite: true,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   autoplaySpeed: 0,
//   speed: 7000,
//   cssEase: 'linear',
//   draggable: false,
//   swipe: false,
//   pauseOnFocus: false,
//   pauseOnHover: false
// });

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');
